export const SAMPLE = "/img/photo-puppy.jpg";
export const SUBJECT = "35% 32%";

export const ISO = [100, 200, 400, 800, 1600, 3200, 6400];
export const APERTURE = ["f/1.8", "f/2.8", "f/4", "f/5.6", "f/8", "f/11", "f/16"];
export const SPEED = ["1/1000", "1/500", "1/250", "1/125", "1/60", "1/30", "1/15"];

export const FRAMINGS = [
  { id: "general", scale: 1, es: ["Plano general", "Se ve todo el lugar: cuenta dónde estás."], en: ["Wide shot", "Shows the whole place: tells where you are."] },
  { id: "medio", scale: 1.8, es: ["Plano medio", "El protagonista y un poco del fondo."], en: ["Medium shot", "The subject and a bit of background."] },
  { id: "primer", scale: 3, es: ["Primer plano", "La cara llena la foto: muestra emociones."], en: ["Close-up", "The face fills the photo: shows emotions."] },
  { id: "detalle", scale: 5, es: ["Plano detalle", "Un ojo, una flor, una textura pequeñita."], en: ["Detail shot", "An eye, a flower, a tiny texture."] },
];

export const LIGHTS = [
  { id: "golden", color: "bg-amber-200", es: ["Hora dorada", "Al amanecer o atardecer la luz es suave y dorada. ¡La favorita de los fotógrafos!"], en: ["Golden hour", "At sunrise or sunset light is soft and golden. Photographers' favorite!"] },
  { id: "window", color: "bg-sky-200", es: ["Luz de ventana", "Pon a tu modelo al lado de una ventana: luz suave sin flash."], en: ["Window light", "Place your model next to a window: soft light, no flash."] },
  { id: "side", color: "bg-violet-200", es: ["Luz lateral", "La luz de un lado crea sombras y da volumen. ¡Se ve más 3D!"], en: ["Side light", "Light from one side creates shadows and depth. Looks more 3D!"] },
  { id: "back", color: "bg-pink-200", es: ["Contraluz", "El sol detrás del sujeto crea siluetas mágicas."], en: ["Backlight", "Sun behind the subject creates magical silhouettes."] },
];

export const WHITE_BALANCE = [
  { id: "auto", filter: "none", es: "Auto", en: "Auto" },
  { id: "day", filter: "sepia(0.15) saturate(1.1)", es: "Luz de día", en: "Daylight" },
  { id: "cloudy", filter: "sepia(0.4) saturate(1.3) hue-rotate(-8deg)", es: "Nublado (más cálido)", en: "Cloudy (warmer)" },
  { id: "tungsten", filter: "hue-rotate(185deg) saturate(0.6) sepia(0.1) hue-rotate(170deg)", es: "Bombillo (más frío)", en: "Tungsten (cooler)" },
];

export const CAMERAS = [
  { id: "kidizoom", brand: "VTech", model: "KidiZoom", age: "5-8", es: "Cámara resistente hecha para niños pequeños, ¡aguanta caídas!", en: "Tough camera made for little kids, survives drops!" },
  { id: "instax", brand: "Fujifilm", model: "Instax Mini", age: "6+", es: "Cámara instantánea: la foto sale impresa al momento.", en: "Instant camera: the photo prints right away." },
  { id: "phone", brand: "Samsung", model: "Galaxy (modo Pro)", age: "8+", es: "Samsung ya no fabrica cámaras, pero sus celulares Galaxy tienen modo Pro para practicar ISO, velocidad y balance de blancos.", en: "Samsung no longer makes cameras, but Galaxy phones have a Pro mode to practice ISO, speed and white balance." },
  { id: "canon", brand: "Canon", model: "EOS R100 / Rebel T7", age: "10+", es: "Cámaras profesionales para principiantes, con modo guiado que explica cada ajuste.", en: "Beginner pro cameras with a guided mode that explains each setting." },
  { id: "nikon", brand: "Nikon", model: "D3500 / Z30", age: "10+", es: "Ligeras y fáciles, con un modo GUIDE que enseña paso a paso.", en: "Light and easy, with a GUIDE mode that teaches step by step." },
  { id: "sony", brand: "Sony", model: "ZV-E10", age: "10+", es: "Ideal para fotos y videos, perfecta para futuros creadores de contenido.", en: "Great for photos and video, perfect for future content creators." },
];

export const PHOTO_TEXT = {
  es: {
    title: "Taller de fotografía de Lumi",
    triangle: "El triángulo de exposición",
    triangleSub: "Mueve los controles y mira cómo cambia la foto.",
    iso: "ISO: qué tan sensible es la cámara a la luz. Más alto = más luz, pero más 'puntitos' (ruido).",
    aperture: "Apertura: qué tan abierta está la 'pupila' del lente. Número pequeño = más luz y fondo borroso.",
    speed: "Velocidad: cuánto tiempo se abre la cámara. Más lenta = más luz, pero lo que se mueve sale movido.",
    dark: "Muy oscura: sube el ISO, abre la apertura o baja la velocidad.",
    bright: "Muy clara: baja el ISO, cierra la apertura o sube la velocidad.",
    perfect: "¡Exposición perfecta!",
    framing: "Encuadres",
    thirds: "La regla de los tercios",
    thirdsSub: "Imagina 9 cuadritos. Pon al protagonista donde se cruzan las líneas. ¡Toca un cruce!",
    thirdsOk: "¡Muy bien! Así la foto se ve más interesante.",
    thirdsTry: "Toca uno de los 4 cruces de las líneas.",
    light: "El manejo de la luz",
    wb: "Balance de blancos",
    wbSub: "Hace que el blanco se vea blanco. Cambia el ambiente de la foto: cálido o frío.",
    cameras: "Cámaras para empezar",
    age: "Edad",
  },
  en: {
    title: "Lumi's photo workshop",
    triangle: "The exposure triangle",
    triangleSub: "Move the controls and watch the photo change.",
    iso: "ISO: how sensitive the camera is to light. Higher = more light, but more 'dots' (noise).",
    aperture: "Aperture: how open the lens 'pupil' is. Small number = more light and blurry background.",
    speed: "Shutter speed: how long the camera stays open. Slower = more light, but moving things blur.",
    dark: "Too dark: raise ISO, open the aperture or slow the speed.",
    bright: "Too bright: lower ISO, close the aperture or speed up.",
    perfect: "Perfect exposure!",
    framing: "Framing",
    thirds: "The rule of thirds",
    thirdsSub: "Imagine 9 little boxes. Put the subject where lines cross. Tap a crossing!",
    thirdsOk: "Great! That makes the photo more interesting.",
    thirdsTry: "Tap one of the 4 line crossings.",
    light: "Working with light",
    wb: "White balance",
    wbSub: "Makes white look white. Changes the mood: warm or cool.",
    cameras: "Cameras to get started",
    age: "Age",
  },
};
